module.exports = __webpack_public_path__ + "img/pigment_3.8929c1d7.png";